/**
 * Randall's Refined Scripts — Theme JavaScript
 * =============================================
 * Main entry point that imports and initializes all modules.
 *
 * Module files:
 * - navigation.js  — Mobile nav, search modal, sticky header
 * - accessibility.js — Focus management, skip links, a11y utilities
 * - animations.js — Intro animation, scroll reveal, transitions
 */

var RRS = window.RRS || {};

/**
 * Theme Initialization
 * Coordinates all module initialization
 */
RRS.Theme = (function() {
  'use strict';

  function init() {
    // Initialize all modules
    if (RRS.Navigation && typeof RRS.Navigation.init === 'function') {
      RRS.Navigation.init();
    }

    if (RRS.Accessibility && typeof RRS.Accessibility.init === 'function') {
      RRS.Accessibility.init();
    }

    if (RRS.Animations && typeof RRS.Animations.init === 'function') {
      RRS.Animations.init();
    }

    // Emit custom event for third-party integrations
    document.dispatchEvent(new CustomEvent('rrs:theme:ready'));
  }

  return {
    init: init
  };
})();

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', RRS.Theme.init);
} else {
  RRS.Theme.init();
}
